
import React from "react";
import { FormFieldType } from "@/types/form";
import { FieldWrapper } from "./FieldWrapper";
import { InstructionBox } from "../components";

interface RichTextInstructionProps {
  element: FormFieldType;
}

export const RichTextInstructionField: React.FC<RichTextInstructionProps> = ({ element }) => {
  if (!element.text) return null;
  
  return (
    <FieldWrapper element={element}>
      <InstructionBox>
        <div 
          className="text-sm richtext-content"
          dangerouslySetInnerHTML={{ __html: element.text }}
        />
      </InstructionBox>
    </FieldWrapper>
  );
};

export default RichTextInstructionField;
